module.exports = __webpack_public_path__ + "img/logo.6ba72e50.png";